/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetManualOCLimits: BridgeCommands.Command<
    Types.Nvapp.Overclockingnvc.SetManualOCLimitsParameters,
    Types.Nvapp.Overclockingnvc.SetManualOCLimitsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'OverClockingNvc',
    method: 'SetManualOCLimits',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StartOcManualScan: BridgeCommands.Command<
    Types.Nvapp.Overclockingnvc.StartOcManualScanParameters,
    Types.Nvapp.Overclockingnvc.StartOcManualScanReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'OverClockingNvc',
    method: 'StartOcManualScan',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StopOcManualScan: BridgeCommands.Command<
    Types.Nvapp.Overclockingnvc.StopOcManualScanParameters,
    Types.Nvapp.Overclockingnvc.StopOcManualScanReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'OverClockingNvc',
    method: 'StopOcManualScan',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EnableBackgroundOcScan: BridgeCommands.Command<
    Types.Nvapp.Overclockingnvc.EnableBackgroundOcScanParameters,
    Types.Nvapp.Overclockingnvc.EnableBackgroundOcScanReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'OverClockingNvc',
    method: 'EnableBackgroundOcScan',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EnableAutotuneOc: BridgeCommands.Command<
    Types.Nvapp.Overclockingnvc.EnableAutotuneOcParameters,
    Types.Nvapp.Overclockingnvc.EnableAutotuneOcReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'OverClockingNvc',
    method: 'EnableAutotuneOc',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RestoreOcDefault: BridgeCommands.Command<
    Types.Nvapp.Overclockingnvc.RestoreOcDefaultParameters,
    Types.Nvapp.Overclockingnvc.RestoreOcDefaultReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'OverClockingNvc',
    method: 'RestoreOcDefault',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetFanSettings: BridgeCommands.Command<
    Types.Nvapp.Overclockingnvc.SetFanSettingsParameters,
    Types.Nvapp.Overclockingnvc.SetFanSettingsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'OverClockingNvc',
    method: 'SetFanSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetPerfProfile: BridgeCommands.Command<
    Types.Nvapp.Overclockingnvc.SetPerfProfileParameters,
    Types.Nvapp.Overclockingnvc.SetPerfProfileReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'OverClockingNvc',
    method: 'SetPerfProfile',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SaveManualOCProfile: BridgeCommands.Command<
    Types.Nvapp.Overclockingnvc.SaveManualOCProfileParameters,
    Types.Nvapp.Overclockingnvc.SaveManualOCProfileReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'OverClockingNvc',
    method: 'SaveManualOCProfile',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ApplyManualOC: BridgeCommands.Command<
    Types.Nvapp.Overclockingnvc.ApplyManualOCParameters,
    Types.Nvapp.Overclockingnvc.ApplyManualOCReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'OverClockingNvc',
    method: 'ApplyManualOC',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DeleteManualOCProfile: BridgeCommands.Command<
    Types.Nvapp.Overclockingnvc.DeleteManualOCProfileParameters,
    Types.Nvapp.Overclockingnvc.DeleteManualOCProfileReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'OverClockingNvc',
    method: 'DeleteManualOCProfile',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetManualOCProfileRebootRestorePreference: BridgeCommands.Command<
    Types.Nvapp.Overclockingnvc.SetManualOCProfileRebootRestorePreferenceParameters,
    Types.Nvapp.Overclockingnvc.SetManualOCProfileRebootRestorePreferenceReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'OverClockingNvc',
    method: 'SetManualOCProfileRebootRestorePreference',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const AcknowledgeManualOCStartupRecoveryMessage: BridgeCommands.Command<
    Types.Nvapp.Overclockingnvc.AcknowledgeManualOCStartupRecoveryMessageParameters,
    Types.Nvapp.Overclockingnvc.AcknowledgeManualOCStartupRecoveryMessageReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'OverClockingNvc',
    method: 'AcknowledgeManualOCStartupRecoveryMessage',
    persistent: false
};

export const Overclockingnvc = {
SetManualOCLimits,
StartOcManualScan,
StopOcManualScan,
EnableBackgroundOcScan,
EnableAutotuneOc,
RestoreOcDefault,
SetFanSettings,
SetPerfProfile,
SaveManualOCProfile,
ApplyManualOC,
DeleteManualOCProfile,
SetManualOCProfileRebootRestorePreference,
AcknowledgeManualOCStartupRecoveryMessage
};
